import View from './View'

const Container = ({ condoData }) => {
  return <View title="Excluir Condominio" condoData={condoData} />
}

export default Container
